export default function () {
    // Men filter stuff
    const menFilterListAnchors = document.querySelectorAll('.tb__list-filters a');
    const menGridItems = document.querySelectorAll('.tb__list-grid-item');
    // Women filter stuff
    const womenFilterListAnchors = document.querySelectorAll('.tb__list-wfilters a');
    const womenGridItems = document.querySelectorAll('.tb__list-wgrid-item');

    const handleItemsFilter = (category, items, anchors) => {
        [...items].map(item => item.classList.add('filtered'));
        [...anchors].map(anchor => anchor.classList.remove('active'));
        if (category) {
            const selectedAnchor = [...anchors].find(item => item.getAttribute('rel') === category);
            if (selectedAnchor) selectedAnchor.classList.add('active');
            const filterValue = `category_${category}`;
            items.forEach(item => {
                if (item.classList.contains(filterValue)) {
                    item.dataset.filter = true;
                    item.classList.add('active');
                } else {
                    item.dataset.filter = false;
                    item.classList.remove('active');
                }
            });
        } else {
            const selectedAnchor = [...anchors].find(item => item.getAttribute('rel') === "");
            [...items].map(item => {
                item.dataset.filter = false;
                item.classList.remove('filtered');
                if (selectedAnchor) selectedAnchor.classList.add('active');
            });
        }
    }

    if (menGridItems?.length && menFilterListAnchors?.length) {
        menFilterListAnchors.forEach(anchor => {
            anchor.addEventListener('click', (e) => {
                const category = e.currentTarget.getAttribute('rel');
                handleItemsFilter(category, menGridItems, menFilterListAnchors);
            })
        })
    }

    if (womenGridItems?.length && womenFilterListAnchors?.length) {
        womenFilterListAnchors.forEach(anchor => {
            anchor.addEventListener('click', (e) => {
                const category = e.currentTarget.getAttribute('rel');
                handleItemsFilter(category, womenGridItems, womenFilterListAnchors);
            })
        })
    }

    window.scrollAndFilter = (target, category, grid) => {
        let targetElement = document.querySelector(target);
        let targetPosition = targetElement?.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({
            top: targetPosition,
            behavior: 'smooth' // Questo aggiunge un'animazione fluida
        });
        if (grid === 'men') {
            handleItemsFilter(category, menGridItems, menFilterListAnchors);
        }
        if (grid === 'women') {
            handleItemsFilter(category, womenGridItems, womenFilterListAnchors);
        }
    }
}
